import React from 'react';
import { Button, Label, Switch } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';
export default function HazmatRateConditionField({ condition, onChange, onRemove, }) {
    const { criteria: value } = condition;
    function handleRemove() {
        onRemove(condition);
    }
    function handleChange(criteria) {
        onChange(Object.assign(Object.assign({}, condition), { criteria }));
    }
    return (React.createElement(FormGrid, null,
        React.createElement(Label, { className: "w-48" }, "Hazmat"),
        React.createElement("div", { className: "flex items-center space-x-2" },
            React.createElement(Switch, { id: "hazmat-toggle", value: value, checked: value, onCheckedChange: handleChange }),
            React.createElement(Label, { htmlFor: "hazmat-toggle" }, "Hazmat")),
        React.createElement("div", null,
            React.createElement(Button, { variant: "icon", onClick: handleRemove },
                React.createElement(Trash, { className: "w-3.5 h-3.5" })))));
}
